/*
   * Форма обратной связи
   */
//Validate feedback form
let form_feedback_rules = {
    focusCleanup: true,
    errorElement: 'div',
    errorClass: 'alert alert-error',
    highlight: function (element, errorClass) {
        $(element).parent().addClass('error');
        $(element).addClass('error');
    }, unhighlight: function (element, errorClass) {
        $(element).parent().removeClass('error');
        $(element).removeClass('error');
    },
    rules: {
        name: "required",
        email: {
            required: true,
            email: true
        },
        message: "required",
    },
    messages: {
        required: 'Заполните это поле.',
        name: {
            required: "Пожалуйста, введите Имя",
        },
        email: {
            required: "Пожалуйста, введите Эл.адрес",
            email: "Введите правильный эл.адрес"
        },
        message: {
            required: "Напишите сообщение"
        },
    }
};


$('.feedback-button').on('click', function (e) {
    $.arcticmodal('close');
    $.arcticmodal({
        type: 'ajax',
        url: '/feedback/',
        ajax: {
            type: 'GET',
            cache: false,
            dataType: 'html',
            success: function (data, el, responce) {
                var h = $('<div class="box-modal">' +
                    '<div class="box-modal_close arcticmodal-close">X</div>' +
                    '<p><b /></p><p />' +
                    '</div>');
                $('P:last', h).html(responce);
                data.body.html(h);
                $(".box-modal form[name=form-feedback]").validate(form_feedback_rules);
            }
        }
    });
});

$(document).on('submit', '.form-feedback', function (e) {
    let form_feedback = $("form[name='form-feedback']");
    form_feedback.validate(form_feedback_rules);

    if($(this).closest(".no-ajax").length ) {
        //Выход, если это не модальное окно
        return;
    }
    e.preventDefault();
    if (form_feedback.valid() === false) {
        return;
    }

    let $this = $(this);
    let $alert = $this.find('.alert-all');
    let myfiles = $(this).find('[name=images]');
    let dataForm = new FormData(this);
    let i = 0;
    if (myfiles.length > 0) {
        for (i = 0; i < myfiles.length && i < 5; i++) {
            dataForm.append('images[' + i + ']', myfiles[i]);
        }
    }

    $.ajax({
        processData: false,
        contentType: false,
        cache: false,
        async: false,
        //context: $(this), // Указываем форму в качестве контекста для this.
        data: dataForm,
        traditional: true,
        beforeSend: function (jqXHR, settings) {
        },
        type: "POST",
        url: "/feedback/",
        dataType: 'json',
        timeout: 60000,
        error: function (json) {
            if (json.status === 422) {
                $alert.html('Ошибка').show();
                console.log(json.responseJSON);
                $.each(json.responseJSON.errors, function (i, error) {
                    var el = $(document).find('[name="'+i+'"]');
                    el.after($('<span class="ajax alert">'+error[0]+'</span>'));
                });
            } else {
                $alert.html('Ошибка сервера').show();
            }
        },
        success: function (data, textStatus, jqXHR) {
            console.log('succ', data, textStatus, jqXHR);
            if (data.result == 'ok') {
                $this.parent().html(data.msg);
                $this.hide();
            } else {
                $this.find('.alert-all').html(data.msg).show();
            }
        }
    });
});